import { Component } from '@angular/core';

import { CommonService } from '../../services/common.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'ag-cell-num-to-perc',
  template: ` <span>{{ value }}</span> `,
})
export class NumberToPercentageComponent {
  value: string | number;

  constructor(private cService: CommonService, private rptService: ReportsService) {}

  agInit(params: { value: any }): void {
    if (params.value === 'N/A') {
      this.value = params.value;
    } else {
      this.value = this.cService.displayNumberAsPercentage(params.value, this.rptService.currentReportMeta.name);
    }
  }
}
